import {Box, styled, Typography} from "@mui/material"
import React from "react"
import moment from "moment/moment"
import {validator} from "../../../../../anwendungskonfigurator/misc/answer-validations"

const ProduktBox = styled((Box))(({theme}) => theme.ProduktErgebnisEntryBox)

const DATESIGINIFIER = "-"
const NUMBERRANGE = "from"
const SELECT = "select"
const BOOLEAN = "value"

const displayRange = (range) => {
    if (!range) {
        return "-"
    }
    if (NUMBERRANGE in range) {
        if (range.from.includes(DATESIGINIFIER)){
            return `${moment(range.from, "YYYY-MM-DD").format("DD.MM.YYYY")} bis ${moment(range.till, "YYYY-MM-DD").format("DD.MM.YYYY")}`
        } else {
            return `${range.from} bis ${range.till} `
        }
    }
    if (SELECT in range) {
        return range.select.join(" ,")
    }
    if (BOOLEAN in range) {
        return range.value ? "Ja" : "Nein"
    }
}

const stateColor = (theme, validValue, merkmalFullfillsProdukt) => {
    if (!validValue) {
        return {backgroundColor: "#fff"}
    }
    return {
        backgroundColor: merkmalFullfillsProdukt
            ? theme.palette.success.main
            : theme.palette.error.main,
    }
}

const ProduktErgebnisEntry = ({produkt, searchParameter, merkmal}) => {
    const merkmalFullfillsProdukt = validator(
        searchParameter?.kunde?.[merkmal.id],
        produkt.merkmale?.[merkmal.id],
    )

    return (
        <Box
            sx={theme =>
                stateColor(
                    theme,
                    produkt.merkmale?.[merkmal.id],
                    merkmalFullfillsProdukt,
                )
            }
            p={1}
        >
            {produkt.merkmale?.[merkmal.id] ? (
                <ProduktBox>
                    <Typography>
                        {displayRange(produkt.merkmale?.[merkmal.id])}
                    </Typography>
                    <Typography>{produkt.merkmale?.[merkmal.id].gewicht || 0}</Typography>
                </ProduktBox>
            ) : (
                <Typography>-</Typography>
            )}
        </Box>
    )
}

export default ProduktErgebnisEntry
